import React__default from 'react';
import styles from './styles.css.js';
import { ExpertJoinedBusinessMessageComponent } from './ExpertJoinedBusinessMessage.generated.js';

var ExpertJoinedBusinessMessage = function ExpertJoinedBusinessMessage(_a) {
  var richCard = _a.richCard;
  var expertId = richCard.expertId;
  return React__default.createElement(ExpertJoinedBusinessMessageComponent, {
    variables: {
      vanityIdOrId: expertId
    }
  }, function (_a) {
    var data = _a.data;

    if (data && data.findExpert) {
      var _b = data.findExpert,
          department = _b.department,
          shortName = _b.shortName;
      var category = department.topLevelCategory;
      return React__default.createElement("div", {
        className: styles.container
      }, React__default.createElement("div", {
        className: styles.message
      }, React__default.createElement("span", {
        className: styles.name
      }, shortName), " joined the conversation"), category && React__default.createElement("div", {
        className: styles.category
      }, category.singularDisplayName, " Expert"));
    } else {
      return null;
    }
  });
};

export default ExpertJoinedBusinessMessage;
//# sourceMappingURL=index.js.map
